import { render, staticRenderFns } from "./SetContacts.vue?vue&type=template&id=a0cafbc2&scoped=true&"
import script from "./SetContacts.vue?vue&type=script&lang=js&"
export * from "./SetContacts.vue?vue&type=script&lang=js&"
import style0 from "./SetContacts.vue?vue&type=style&index=0&id=a0cafbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cafbc2",
  null
  
)

export default component.exports